// Русская локализация для Select2
// Функция для настройки русской локализации
function setupSelect2Russian() {
  if (typeof window.jQuery !== 'undefined' && window.jQuery.fn.select2) {
    window.jQuery.fn.select2.defaults.set('language', {
      errorLoading: function () {
        return 'Результат не может быть загружен.';
      },
      inputTooLong: function (args) {
        var overChars = args.input.length - args.maximum;
        var message = 'Пожалуйста, введите на ' + overChars + ' символ';
        if (overChars >= 2 && overChars <= 4) {
          message += 'а';
        } else if (overChars >= 5) {
          message += 'ов';
        }
        message += ' меньше';
        return message;
      },
      inputTooShort: function (args) {
        var remainingChars = args.minimum - args.input.length;
        var message = 'Пожалуйста, введите ещё ' + remainingChars + ' символ';
        if (remainingChars >= 2 && remainingChars <= 4) {
          message += 'а';
        } else if (remainingChars >= 5) {
          message += 'ов';
        }
        return message;
      },
      loadingMore: function () {
        return 'Загружается ещё...';
      },
      maximumSelected: function (args) {
        var message = 'Вы можете выбрать не более ' + args.maximum + ' элемент';
        if (args.maximum >= 2 && args.maximum <= 4) {
          message += 'а';
        } else if (args.maximum >= 5) {
          message += 'ов';
        }
        return message;
      },
      noResults: function () {
        return 'Совпадений не найдено';  
      },
      searching: function () {
        return 'Поиск...';
      },
      removeAllItems: function () {
        return 'Удалить все элементы';
      }
    });
    console.log('Select2 русская локализация установлена');
  } else {
    console.warn('Select2 не найден для установки локализации');
  }
}

// Настраиваем локализацию при загрузке DOM
// document.addEventListener('DOMContentLoaded', setupSelect2Russian);

// Также настраиваем при Turbo загрузке
document.addEventListener('turbo:load', setupSelect2Russian);

// Если jQuery уже загружен, настраиваем сразу
if (typeof window.jQuery !== 'undefined' && window.jQuery.fn.select2) {
  setupSelect2Russian();
}
